const getDataEd = () => {
  return [
    {
      id: 1,
      schoolName: "Universitas Lampung",
      study: "Informatics engineering",
      time: "Sep 2020 - present",
      grade: "Grade: 3.91 / 4.00",
    },
    {
      id: 2,
      schoolName: "Dicoding Academy",
      study: "Front-end React Developer",
      time: "Aug 2022 - Jan 2023",
      grade: "Grade: 92.1 / 100",
    },
    {
      id: 3,
      schoolName: "SMAN 5 B. Lampung",
      study: "Science",
      time: "Aug 2017 - Apr 2020",
      grade: "Grade: 93.23 / 100",
    },
  ];
};

export { getDataEd };
